"use strict";

// Header scroll (5px add / 4px remove)
(() => {
    const header = document.querySelector('header.header');
    if (!header) return;

    const ADD_AT = 5;
    const REMOVE_AT = 4;

    let ticking = false;

    const onScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop >= ADD_AT) {
            header.classList.add('header-scroll');
        } else if (scrollTop <= REMOVE_AT) {
            header.classList.remove('header-scroll');
        }

        ticking = false;
    };

    window.addEventListener(
        'scroll',
        () => {
            if (!ticking) {
                requestAnimationFrame(onScroll);
                ticking = true;
            }
        },
        { passive: true }
    );

    requestAnimationFrame(onScroll);
})();

function initScrollProgressBar() {
    if (window.innerWidth >= 1024) return;
    if (typeof siteSettings !== "undefined" && siteSettings.isFrontPage) return;

    const header = document.querySelector('header.header');
    if (!header) return;

    const progressBarContainer = document.createElement('div');
    progressBarContainer.id = 'progress-container';
    progressBarContainer.style.display = 'none';

    const progressBar = document.createElement('div');
    progressBar.id = 'progress-bar';

    progressBarContainer.appendChild(progressBar);
    header.appendChild(progressBarContainer);

    window.addEventListener('scroll', () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const docHeight =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;

        // керування видимістю
        if (scrollTop === 0) {
            progressBarContainer.style.display = 'none';
            return;
        } else {
            progressBarContainer.style.display = 'block';
        }

        if (docHeight <= 0) return;

        const progress = (scrollTop / docHeight) * 100;
        progressBar.style.width = progress + '%';
    });
}

document.addEventListener('DOMContentLoaded', initScrollProgressBar);

// Animate Scroll
(() => {
    const header = document.querySelector('header');
    const getHeaderHeight = () => header ? header.offsetHeight : 0;

    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const id = link.getAttribute('href');
        if (!id || id === '#') return;

        const target = document.querySelector(id);
        if (!target) return;

        e.preventDefault();

        const targetTop =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            getHeaderHeight();

        window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
        });
    });
})();

// Mobile Nav Toggle
(() => {
    const body = document.body;
    const burger = document.querySelector('button.burger');
    const nav = document.querySelector(".header-menu");
    const header = document.querySelector("header.header");

    if (!burger || !nav) return;

    burger.addEventListener('click', () => {
        body.classList.toggle('overflow-hidden');
        nav.classList.toggle('active');
        burger.classList.toggle('burger-active');
        header.classList.toggle('mobile-menu-active');
    });
})();

// Mbbile nav submenu toggle
(() => {
    const menu = document.querySelector('.header-menu');
    if (!menu) return;

    const items = menu.querySelectorAll('li.menu-item-has-children');

    items.forEach(item => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();

            items.forEach(el => {
                if (el !== item) {
                    el.classList.remove('active');
                }
            });

            item.classList.toggle('active');
        });
    });
})();


// Mobile SubNav open
(() => {
    const header = document.querySelector('.header');
    if (!header) return;

    const items = header.querySelectorAll(
        '.genesis-nav-menu > ul > .menu-item-type-custom'
    );
    if (!items.length) return;

    const DURATION = 150; // ms

    items.forEach((item) => {
        const submenu = item.lastElementChild;
        if (!submenu) return;

        // встановлюємо базові стилі через JS
        submenu.style.maxHeight = '0';
        submenu.style.overflow = 'hidden';
        submenu.style.transition = `max-height ${DURATION}ms ease`;

        item.addEventListener('click', () => {
            const isMobile = header.classList.contains('header-mobile');

            if (!isMobile) {
                item.classList.toggle('open');
                return;
            }

            item.classList.toggle('open');

            if (submenu.style.maxHeight && submenu.style.maxHeight !== '0px') {
                // закриття
                submenu.style.maxHeight = '0';
            } else {
                // відкриття
                submenu.style.maxHeight = submenu.scrollHeight + 'px';
            }
        });
    });
})();

// Social Share
(() => {
    const socialSpans = document.querySelectorAll('.social-share-item');

    if (!socialSpans.length) return;

    const pageUrl = window.location.href;

    socialSpans.forEach((span) => {
        span.addEventListener('click', async () => {
            const link = span.dataset.link;
            const url = span.dataset.url || pageUrl;

            if (!link) {
                try {
                    // Копіюємо URL
                    await navigator.clipboard.writeText(pageUrl);

                    // Native Share API (mobile / modern browsers)
                    if (navigator.share) {
                        navigator.share({
                            url: pageUrl,
                            title: document.title
                        });
                    } else {
                        // Fallback: просто скопійовано
                        console.info('Link copied to clipboard:', pageUrl);
                    }
                } catch (err) {
                    console.error('Share failed:', err);
                }

                return;
            }

            const fullUrl = link.includes('http')
                ? link + url
                : 'https://' + link + url;

            window.open(fullUrl, '_blank', 'noopener,noreferrer');
        });
    });
})();
// popup
document.addEventListener("click", function (e) {
    if (e.target.closest(".show-popup-form")) {
        e.preventDefault();
        const form = document.querySelector(".popup-wrap");
        if (form) {
            form.style.display = "flex";
        }
    }

    if (
        e.target.closest(".close-popup") ||
        e.target.classList.contains("popup-wrap")
    ) {
        const form = document.querySelector(".popup-wrap");
        if (form) {
            form.classList.remove("show-popup");
            form.style.display = "none";
        }
    }
});


(() => {
    const TARGET_CHARS = ['.', '?', '!'];

    const processHeadings = () => {
        const headings = document.querySelectorAll('h1, h2');

        headings.forEach(heading => {
            // захист від повторної обробки
            if (heading.querySelector('.text-orange')) return;

            const walker = document.createTreeWalker(
                heading,
                NodeFilter.SHOW_TEXT,
                null,
                false
            );

            let lastTextNode = null;

            while (walker.nextNode()) {
                const node = walker.currentNode;
                if (node.textContent.trim()) {
                    lastTextNode = node;
                }
            }

            if (!lastTextNode) return;

            const text = lastTextNode.textContent;
            const lastChar = text.slice(-1);

            if (!TARGET_CHARS.includes(lastChar)) return;

            lastTextNode.textContent = text.slice(0, -1);

            const span = document.createElement('span');
            span.className = 'text-orange';
            span.textContent = lastChar;

            lastTextNode.parentNode.insertBefore(
                span,
                lastTextNode.nextSibling
            );
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', processHeadings);
    } else {
        processHeadings();
    }
})();
